import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const citiesLookup = (payload: { searchText: string; stateId?: string }) => {
  const url = `${API_ENDPOINTS.lookupCities}?${queryString.stringify({ search: payload.searchText || '', state_id: payload.stateId })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const countriesLookup = (payload: { searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupCountries}?${queryString.stringify({ search: payload.searchText || '' })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const statesLookup = (payload: { searchText: string; countryId?: string }) => {
  const url = `${API_ENDPOINTS.lookupStates}?${queryString.stringify({ search: payload.searchText || '', country_id: payload.countryId })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const areaLookup = async (payload: { searchText: string; cityId?: string | string[]; is_active?: number }) => {
  if (Array.isArray(payload.cityId)) {
    if (payload.cityId.length === 0) return [];
    
    // Call different APIs for all cities
    const promises = payload.cityId.map(id => {
      const url = `${API_ENDPOINTS.lookupAreas}?${queryString.stringify({ search: payload.searchText || '', city_id: id, is_active: payload.is_active })}`;
      return http.get(url).then((response: any) => response.records || []);
    });
    
    const results = await Promise.all(promises);
    return results.flat();
  } else {
    const url = `${API_ENDPOINTS.lookupAreas}?${queryString.stringify({ search: payload.searchText || '', city_id: payload.cityId, is_active: payload.is_active })}`;
    return http.get(url).then((response: any) => response.records || []);
  }
};

const genericLookup = (payload: { key: string; searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupGeneric}?${queryString.stringify({
    key: payload.key,
    search: payload.searchText,
  })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const propertyTypeLookup = (payload: { searchText: string; is_active?: number }) => {
    const url = `${API_ENDPOINTS.propertyTypeLookup}?${queryString.stringify({
        search: payload.searchText,
        is_active: payload.is_active,
    })}`;
    return http.get(url).then((response: any) => response.records || []);
}

const amenityLookup = (payload: { searchText: string; is_active?: number }) => {
  const url = `${API_ENDPOINTS.amenityLookup}?${queryString.stringify({
      search: payload.searchText || '',
      is_active: payload.is_active,
  })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const categoryLookup = (payload: { searchText: string; is_active?: number }) => {
  const url = `${API_ENDPOINTS.categoryLookup}?${queryString.stringify({
      search: payload.searchText || '',
      is_active: payload.is_active,
  })}`;
  return http.get(url).then((response: any) => response.records || []);
};

const CommonService = {
  citiesLookup,
  countriesLookup,
  statesLookup,
  areaLookup,
  genericLookup,
  propertyTypeLookup,
  amenityLookup,
  categoryLookup,
};

export default CommonService;
